/** Repair Windows-1252 mojibake of UTF-8 quotes, then use ASCII inches. */
export function normalizeCatalogText(value: string | null | undefined): string {
  if (!value) {
    return '';
  }
  return value
    .replace(/\u00e2\u20ac\u2122/g, '\u2019')
    .replace(/\u00e2\u0080\u0099/g, '\u2019')
    .replace(/\u2019\u2019/g, '"')
    .replace(/(\d)\u2019/g, '$1"')
    // ASCII caret cubes (e.g. 30M^3 / 500m^3) → proper cubic metres
    .replace(/(\d)\s*[Mm]\^3\b/g, '$1 m\u00b3')
    .replace(/\b[Mm]\^3\b/g, 'm\u00b3');
}

export function isPropsHtml(html: string): boolean {
  const value = html.trim().toLowerCase();
  return value.startsWith('<ul') || value.startsWith('<table');
}
